
export const APP_NAME = process.env.REACT_APP_NAME || 'Acacia';

export const dateFormat = 'YYYY-MM-DD';